import React from 'react';
import Cookie from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { Routes, Route, useLocation, useNavigate, Navigate } from 'react-router-dom';
import { Result } from 'antd';

import { mainRoutes } from '@src/routes/mainRoutes';
import { resetCookie } from '@src/utils/pendingInitInfo';
import messageCom from '@src/utils/messageCom';

const RouterViews = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  let menuRoutes = [];

  // 组装路由
  const mainRoutesFn = (data) => {
    data.forEach(_menu => {
      if (_menu.children) {
        mainRoutesFn(_menu.children);

        return;
      }

      menuRoutes = [...menuRoutes, _menu];
    });
  };

  mainRoutesFn(mainRoutes)

  // 判断cookie登录状态
  React.useEffect(() => {
    // if (process.env.VERSION !== localStorage.getItem('VERSION')) {
    //   localStorage.setItem('VERSION', process.env.VERSION);
    //   messageCom.warning(t('Please login again'));
      
    //   setTimeout(() => {
    //     resetCookie();
    //     navigate('/login');
    //     window.location.reload();
    //   }, 600)
    // }

    if (!Cookie.get('uID')) {
      resetCookie();
      navigate('/login');
    }
  }, [location]);

  return (
    <Routes>
      {
        menuRoutes.filter(_route => {
          if (_route.link === '/networkPlatform-SmartCPEAcceleration') return process.env.ENV_TYPE !== 'dcc'

          return true;
        }).map(item => (
          !item.routeChildren
            ? <Route path={item.link} key={item.link} element={item.component}></Route>
            : <Route path={`${item.link}/*`} key={item.link} element={item.component}></Route>
        ))
      }
      <Route path="/" element={<Navigate to="/dashboard" />} />
      <Route path="/*" element={<Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
      // extra={}
      />}></Route>
    </Routes>
  )
};

export default RouterViews;